__turbopack_context__.v({
  "image": "BlockSubNavCardGroupSectionCard-module-scss-module__fyWOzG__image",
  "root": "BlockSubNavCardGroupSectionCard-module-scss-module__fyWOzG__root",
});
